import React, {useEffect, useState} from 'react';
import {Home} from "./pages/Home/components/Home";
import {Header} from "./pages/shared/Header/Header";
import {SearchData} from "./pages/shared/Header/HeaderSearch";
import {FORECAST_API_KEY, WEATHER_API_KEY, WEATHER_API_URL} from "./api/api";


function App() {

    const [currentWeather, setCurrentWeather] = useState(null)
    const [forecast, setForecast] = useState(null)

    const handleOnSearchChange = (searchData: SearchData | null) => {
        if (searchData) {
            const [lat, lon] = searchData.value.split(' ');
            const currentWeatherFetch =
                fetch(`${WEATHER_API_URL}/weather?lat=${lat}&lon=${lon}&appid=${WEATHER_API_KEY}&units=metric`);
            const forecastFetch =
                fetch( `${FORECAST_API_KEY}/forecast?latitude=${lat}&longitude=${lon}&hourly=temperature_2m&daily=weathercode,temperature_2m_max,temperature_2m_min,uv_index_max,windspeed_10m_max&timezone=auto`)
            Promise.all([currentWeatherFetch, forecastFetch])
                .then(async (response) => {
                    const weatherResponse = await response[0].json()
                    const forecastResponse = await response[1].json()

                    setCurrentWeather({city:searchData.label, ...weatherResponse})
                    setForecast({city:searchData.label, ...forecastResponse})
                })
                .catch((err) => console.log(err))
        }
    }
    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    const currentWeatherFetch =
                        fetch(`${WEATHER_API_URL}/weather?lat=${latitude}&lon=${longitude}&appid=${WEATHER_API_KEY}&units=metric`);
                    const forecastFetch =
                        fetch( `${FORECAST_API_KEY}/forecast?latitude=${latitude}&longitude=${longitude}&hourly=temperature_2m&daily=weathercode,temperature_2m_max,temperature_2m_min,uv_index_max,windspeed_10m_max&timezone=auto`)
                    Promise.all([currentWeatherFetch, forecastFetch])
                        .then(async (response) => {
                            const weatherResponse = await response[0].json()
                            const forecastResponse = await response[1].json()

                            setCurrentWeather({city: `${weatherResponse.name}, ${weatherResponse.sys.country}`, ...weatherResponse})
                            setForecast({city: weatherResponse.name, ...forecastResponse})
                        })
                        .catch((err) => console.log(err))
                },
                (error) => {
                    alert('Please provide access to your current location or find the necessary city in the search.');
                }
            );
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }, [])

    return (
        <div className='global-container'>
            <div className='container'>
                <Header onSearchChange={handleOnSearchChange}/>
                    {currentWeather && forecast && <Home data={currentWeather} forecast={forecast}/>}
            </div>
        </div>
    );
}

export default App;
